import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError, isStatusOK, isStatusSuccess } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data) && isStatusSuccess(data?.data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const generateOtp = (tokens: any, generateOtpReq: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtp,
    method: 'POST',
    config: apiConfig(tokens),
    body: generateOtpReq,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((error) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: error,
      })
      throw error
    })
}

export const getOtpRequest = (mobileNumber: string, countryCode: any, purpose: 1 | 2, mode = '1') => {
  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode,
      },
      // entityType: 2,
      //  emailAddress,
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode,
        value: '',
        action: 'generate',
      },
    ],
    purpose: purpose,
    // extraInfo: '20000033535',
  }
}

export const getOtpRequestRefund = (mobileNumber: string, countryCode: any, purpose: 1 | 2, mode = '18') => {
  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode,
      },
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
      entityType: 2,
      //  emailAddress,
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode,
        value: '',
        action: 'generate',
      },
    ],
    purpose: purpose,
    // extraInfo: '20000033535',
  }
}

export const getAadhaarOtpRequest = (aadhaarNo: string, mobileNo: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: mobileNo,

        countryCode: '+91',
      },
    },

    scope: 'REQUEST',

    authenticateList: [
      {
        mode: 30,

        action: 'generate',

        aadhaar: {
          number: aadhaarNo,
        },

        consent: btoa(RootStore.consents.getConsent('LINK_AADHAAR')),
      },
    ],

    purpose: 1,

    extraInfo: '20000033535',
  }
}
